import type { CreateCategoryInput, GetCategoriesResponse, UpdateCategoryInput } from "@montatec/contracts"
import { del, get, patch, post } from "../../../lib/fetch"

export const categoriesService = {
    get:    async () => await get<GetCategoriesResponse>("/api/providers/templates/categories").then(res => res.data),
    create: async (data: CreateCategoryInput) => await post(`/api/providers/templates/categories`, data),
    update: async (id: number, data: UpdateCategoryInput) => await patch(`/api/providers/templates/categories/${id}`, data),
    delete: async (id: number) => await del(`/api/providers/templates/categories/${id}`)
}